const API_BASE_URL = process.env.REACT_APP_API_URL;

class ApiCheckService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    const token = localStorage.getItem('clientToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }


  async directionsClient(clienteId) {
    return this.request(`/direccion/cliente/${clienteId}`);
  }

  async myOrders() {
    return this.request(`/venta/`);
  }

  async bancos() {
    return this.request(`/publico/lista_bancos`);
  }

  async createAddress(address) {
    return this.request('/direccion', {
      method: 'POST',
      body: JSON.stringify(address),
    });
  }


  async createOrder(orderData) {
    return this.request('/venta', {
      method: 'POST',
      body: JSON.stringify(orderData),
    });
  }

 
}

export default new ApiCheckService();